module.exports = __webpack_public_path__ + "static/media/swissMedic.db21888a.svg";